import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

const useAssignmentsBasedGradingOptInMutation = ({ stafferPath }) => (
  useMutation({
    mutationFn: ({ nextSetting }: { nextSetting: boolean }) => (
      axios
        .patch(stafferPath, { assignments_based_grading_opt_in: nextSetting })
        .then(res => res.data)
    ),
    mutationKey: ['useAssignmentsBasedGradingOptInMutation'],
  })
);

export default useAssignmentsBasedGradingOptInMutation;
